/**
 * Central mobile navigation definitions shared by main and page layouts.
 * Keeps labels concise, auth-aware, and role-aware.
 */
export const MOBILE_PRIMARY_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'societies', label: 'Societies' },
  { id: 'events', label: 'Events' },
  { id: 'islam', label: 'Islam' },
  { id: 'contact', label: 'Contact' },
  { id: 'messages', label: 'Messages', requiresAuth: true },
  { id: 'profile', label: 'Profile', requiresAuth: true },
];

export const MOBILE_DISCOVER_ITEMS = [
  { id: 'posts', label: 'Posts' },
  { id: 'institutes', label: 'Institutes' },
  { id: 'businesses', label: 'Businesses' },
  { id: 'events', label: 'Events' },
  { id: 'ads', label: 'Ads' },
  { id: 'properties', label: 'Properties' },
  { id: 'turfs', label: 'Turfs' },
  { id: 'points', label: 'Points' },
];

export const MOBILE_ADMIN_ITEMS = [
  { id: 'scrapper', label: 'Scrapper', visibility: 'staff' },
  { id: 'admin', label: 'Admin Portal', visibility: 'admin' },
];

const hasStaffAccess = (user) => !!(user && (user.is_staff || user.is_superuser));
const hasAdminAccess = (user) => !!(hasStaffAccess(user) || ['admin', 'moderator'].includes(user?.role));

export const getVisibleMobileItems = (items, { isAuthenticated, user }) =>
  items.filter((item) => {
    if (item.requiresAuth && !isAuthenticated) return false;
    if (item.visibility === 'staff' && !hasStaffAccess(user)) return false;
    if (item.visibility === 'admin' && !hasAdminAccess(user)) return false;
    return true;
  });

export const isMobileNavItemActive = (location, itemId) => {
  const pathname = location.pathname;
  const params = new URLSearchParams(location.search);
  if (itemId === 'home') return pathname === '/';
  if (itemId === 'profile') return pathname === '/' && params.get('auth') === 'profile';
  if (itemId === 'messages') return pathname === '/messages' || pathname.startsWith('/messages/');
  if (itemId === 'explore') return pathname === '/explore';
  if (itemId === 'contact') return pathname === '/contact';
  if (itemId === 'scrapper') return pathname === '/scrapper';
  if (itemId === 'admin') return pathname === '/admin-portal';
  return pathname === `/${itemId}` || pathname.startsWith(`/${itemId}/`);
};

